<template>
  <div class="user-avatar" :class="{ 'has-ring': showRing }" :style="{ width: size + 'px', height: size + 'px', flex: '0 0 ' + size + 'px' }">
    <div v-if="avatarType === 'initials'" class="user-avatar-circle" :style="{ backgroundColor: avatarColor }">
      <span class="user-avatar-initials" :style="{ fontSize: fontSize + 'px' }">{{ userInitials }}</span>
    </div>
    <div v-else-if="avatarType === 'image' && avatarUrl" class="user-avatar-image">
      <image-with-headers :key="reloadKey" :url="avatarUrl" class="avatar-img"></image-with-headers>
    </div>
    <div v-else class="user-avatar-circle" :style="{ backgroundColor: defaultColor }">
      <span class="user-avatar-initials" :style="{ fontSize: fontSize + 'px' }">{{ userInitials }}</span>
    </div>
    <div v-if="showRing" class="avatar-ring" :class="ringColor"></div>
  </div>
</template>

<script>
import ImageWithHeaders from "@/components/ImageWithHeaders";

export default {
  name: "UserAvatar",
  components: { ImageWithHeaders },
  props: {
    user: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 40
    },
    defaultColor: {
      type: String,
      default: "var(--ld-status-info)"
    },
    showRing: {
      type: Boolean,
      default: false
    },
    ringColor: {
      type: String,
      default: 'is-primary',
      validator: value => ['is-primary', 'is-warning', 'is-success', 'is-danger'].includes(value)
    }
  },
  computed: {
    avatarType() {
      return this.user.avatar_type || 'initials';
    },
    avatarColor() {
      return this.user.avatar_color || this.defaultColor;
    },
    avatarUrl() {
      return this.user.avatar_url;
    },
    userInitials() {
      if (!this.user.name) return '';
      return this.user.name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase())
        .slice(0, 3)
        .join('');
    },
    fontSize() {
      return Math.round(Math.max(this.size * 0.4, 11))
    },
  },
  watch: {
    avatarUrl() {
      this.reloadKey = this.reloadKey + 1;
    }
  },
  data() {
    return {
      reloadKey: 1
    }
  }
}
</script>

<style scoped lang="scss">
.user-avatar {
  display: inline-block;
  position: relative;
  
  &.has-ring {
    margin: 4px;
  }
}

.user-avatar-circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar-initials {
  color: var(--ld-text-inverse);
  font-weight: 500;
  line-height: 1;
}

.user-avatar-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-ring {
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 50%;
  border: 2px solid;
  pointer-events: none;
  
  &.is-primary {
    border-color: var(--ld-status-info);
  }

  &.is-warning {
    border-color: var(--ld-status-warning);
  }

  &.is-success {
    border-color: var(--ld-status-success);
  }

  &.is-danger {
    border-color: var(--ld-status-danger);
  }
}
</style> 